import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { CustomCalendarEvent } from '../warehouse-calendar/warehouse-calendar.component';
import { WarehouseCalendarService } from '../../service/warehouse-calendar.service';
import { ConfirmationService } from 'primeng/api';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InputValidators } from 'src/app/shared/validators/input-validators';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { finalize } from 'rxjs/operators';


@Component({
  selector: 'warehouse-calendar-create',
  templateUrl: './warehouse-calendar-create.component.html',
  styleUrls: ['./warehouse-calendar-create.component.scss']
})
export class WarehouseCalendarCreateComponent extends SessionBaseComponent implements OnInit {

  @Input() checkLicenseNoList: any;

  @Input() calendarEvents: CustomCalendarEvent[] = [];

  @Input() clickDate: any;

  @Input() systemCategory: any;

  @Output() warehouseCalendarImported: EventEmitter<any>;


  confirmationService: ConfirmationService;

  facilityOptions: any[];

  generateParams: any;

  createUser: any;

  updateUser: any;

  form: FormGroup;

  yearLabel!: string;

  submitted: boolean;

  yearList!: any[];

  isLoading: boolean;

  constructor(
    injector: Injector,
    private warehouseCalendarService: WarehouseCalendarService,
    private dropdownOptionsService: DropdownOptionsService,
    private changeDetector: ChangeDetectorRef,
    private fb: FormBuilder) {
    super(injector);
    this.warehouseCalendarImported = new EventEmitter<any>();
    this.checkLicenseNoList = null;

    this.facilityOptions = [];
    this.generateParams = {
      facility:"",
      year:""
    };
    this.createUser = '';
    this.updateUser = '';
    this.isLoading = false;
    this.confirmationService = injector.get(ConfirmationService);
    this.form = this.fb.group({
      facility: ["", Validators.required]
    });
    this.submitted = false;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.dropdownOptionsService.getFacilityOptions().subscribe({
      next: (result) => {
        this.facilityOptions = result.map((x: any) => {
          return {
            label: x.optionDesc,
            value: x.optionCode,
          };
        });
      },
    });

    this.translateService.get('WarehouseCalendar.Calendar.Year')
    .subscribe({
      next: result => {

        this.yearLabel = result;

        var thisYear = new Date().getFullYear();
        this.yearList =  [];
        for(var i = thisYear; thisYear + 10 >= i; i++) {
          let yearObject : any = {};
          yearObject.label = i.toString() + this.yearLabel;
          yearObject.value = i.toString();
          this.yearList.push(yearObject);
        }
        this.generateParams.year = new Date().getFullYear().toString();
      }
    });

  }

  saveBtnClick(event: any): void {
    // 先驗證資料
    if(isNullOrEmpty(this.generateParams.facility)){
      this.toastService.warn(this.translateService.instant('WarehouseCalendar.Alert.CreateCalendar.CheckFacility'));
      return;
    }
    this.isLoading = true;
    this.changeDetector.detectChanges();
    console.log(" saveBtnClick this.isLoading = ",this.isLoading);

    var params = {
      year :  this.generateParams.year,
      facility: this.generateParams.facility,
      userId: this.userProfile.userName,
      systemCategory: this.systemCategory
    };
    console.log(params);

    this.warehouseCalendarService.generateCalendar(params)
      .pipe(finalize(() => {
        this.isLoading = false;
        this.changeDetector.detectChanges();
        console.log(" complete this.isLoading = ",this.isLoading);}))
      .subscribe({next: result => {
        this.toastService.success(this.translateService.instant('WarehouseCalendar.Toast.CreateSuccess'));
      },
      error: (error: any) => {
        if (error.error.errorMsg) {
          this.toastErrorMessage(error.error.errorMsg);
        } else {
          this.toastErrorMessage(error.error);
        }
      }
    });
  }

  optionsDataOnChange(data: any, type: string): void {
    switch (type) {
      case 'facility':
        this.generateParams.facility = data;
        break;
    }
  }
}

